export default __webpack_public_path__ + "static/media/FinanceRealCase2-mobile.251bccda.jpg";